import React from 'react';

import Login from '../../Components/Auth/Login';
import LoginDemo from '../../Components/Auth/LoginDemo';
import Header from '../../Components/Auth/Header';


export default function LoginPage() {

  // console.log("9 - LoginPage : window.location.href=", window.location.href);
  // console.log("10 - process.env=", process.env);

  let demoMode = false;
  if (window.location.href === process.env.REACT_APP_DEMO_URL) {
    demoMode = true;
  }

  if (demoMode) {
    return (
      <div className="auth">
        <Header />
        <LoginDemo />
      </div>
    );
  }
  else {
  return (
    <div className="auth">
      <Header/>
      <Login/>
    </div>
  );
}
}
